<section class="total-container">
  <div class="main-content-container">
    <div (click)="closeWindow()" class="close-window">
      <mat-icon>close</mat-icon>
    </div>

    <div class="toggle-wrapper" *ngIf="!isCustomPlan">
      <div class="buttons_bar">
        <button (click)="changeSubscriptionType(item)" *ngFor="let item of twoButtons"
          [ngClass]="{'activate': subscriptionType === item.value}">{{ item.name | titlecase }}
          <span class="save-tag" *ngIf="item.value === 'ANNUALLY'">Save 30%</span>
        </button>
      </div>
    </div>

    <div class="row plans-row" *ngIf="isCustomPlan">
      <!-- <ng-container *ngFor="let plan of planList"> -->
        <div class="col-md-4 col-12 plan-card-col">
          <div class="individual-options basic-plan">
            <div class="pricing-header">
              <div class="plan-name">Custom Plan(Monthly)</div>
              <div class="plan-price">
                <span class="currency">₹</span>{{
                data?.plan.customMonthly 
                }}
              </div>

              <button class="button free-button mt-2" (click)="upgradeCustomPlan('MONTHLY')">Upgrade</button>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-12 plan-card-col recommended-col">
          <div class="recommended-individual-options">
            <div class="pricing-header">
              <div class="plan-name">Custom Plan(Yearly)</div>
              <div class="plan-price">
                <span class="currency">₹</span>{{
                data?.plan.customYearly
                }}
              </div>

              <button class="button upgrade-pro-button mt-2" (click)="upgradeCustomPlan('ANNUALLY')"> <img alt=""
                  src="./../../../../assets/images/business/recommended.svg"> Upgrade</button>
            </div>
          </div>
        </div>
      <!-- </ng-container> -->
    </div>

    <div class="row plans-row" *ngIf="!isCustomPlan">
      <ng-container *ngFor="let plan of planList">
        <div *ngIf="plan.plan.id === '1efa980b-8bf0-6c12-9b62-639b28d6a93d'" class="col-md-4 col-12 plan-card-col">
          <div class="individual-options basic-plan">
            <div class="pricing-header">
              <div class="plan-name">{{ plan.plan.planName }}</div>
              <div class="plan-price">
                <span class="currency">₹</span>{{
                subscriptionType == 'MONTHLY' ? plan.prices.monthlySellingPrice :
                plan.prices.yearlySellingPrice
                }}<span class="span-tag">{{ subscriptionType === 'MONTHLY' ? '/mo' : '/year' }}</span>
              </div>
            </div>
            <div class="pricing-content">
              <button (click)="upgradePlan(plan)" class="button free-button">Start for Free</button>
              <div class="trial-text">15-day free trial</div>

              <div class="plan-name features-heading" style="margin-top:10px;">What's included?</div>
              <div class="body-desc content-options" style="text-align:justify">
                <div *ngFor="let content of plan.features" class="d-flex gap-15 features">
                  <img alt="" src="./../../../../assets/images/business/feature_check.svg">
                  {{ content }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="plan.plan.id !== '1efa980b-8bf0-6c12-9b62-639b28d6a93d' && plan.plan.recommended === true"
          class="col-md-4 col-12 plan-card-col recommended-col">
          <div [ngClass]="{'recommended-individual-options': plan.plan.recommended === true}"
            class="individual-options">
            <div class="recommended-tags-container">
              <div class="recommended-tag-wrapper">
                <div class="recommended">Most Popular</div>
              </div>
              <div class="free-domain-tag">32K+ bought last months</div>
            </div>
            <div class="pricing-header">
              <div class="plan-name">{{ plan.plan.planName }}</div>
              <div class="plan-price">
                <span class="original-price">
                  <span class="currency">₹</span>{{ subscriptionType == 'MONTHLY' ? plan.prices.monthlyPrice :
                  plan.prices.yearlyPrice }}
                </span>
                <span class="currency">₹</span>{{
                subscriptionType == 'MONTHLY' ? plan.prices.monthlySellingPrice :
                plan.prices.yearlySellingPrice
                }}<span class="span-tag">{{ subscriptionType === 'MONTHLY' ? '/mo' : '/year' }}</span>
              </div>
            </div>
            <div class="pricing-content">
              <button (click)="upgradePlan(plan)" class="button upgrade-pro-button"> <img alt=""
                  src="./../../../../assets/images/business/recommended.svg"> Upgrade to Pro</button>
              <div class="trial-text">7-day free trial</div>

              <div class="plan-name features-heading" style="margin-top:10px;">What's included?</div>
              <div class="body-desc content-options" style="text-align:justify">
                <div
                  *ngFor="let content of ((data?.plan?.paidPlanId != null && !showAll) ? plan.features.slice(0,4) : plan.features); let i = index"
                  class="d-flex gap-15 features">
                  <img alt="" src="./../../../../assets/images/business/feature_check.svg">
                  {{ content }}
                </div>

                <!-- Show the toggle button only when paid and there are more than 6 features -->
                <div *ngIf="data?.plan?.paidPlanId != null && plan?.features?.length > 4" class="mt-2">
                  <button class="btn btn-link p-0" (click)="toggleShowAll()" [attr.aria-expanded]="showAll">
                    {{ showAll ? 'Show less' : 'Show more' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="plan.plan.id !== '1efa980b-8bf0-6c12-9b62-639b28d6a93d' && plan.plan.recommended !== true && plan.prices.yearlySellingPrice > 0"
          class="col-md-4 col-12 plan-card-col">
          <div class="individual-options">
            <div class="free-domain-tag-container">
              <div class="free-domain-tag">Free Domain</div>
            </div>
            <div class="pricing-header">
              <div class="plan-name">{{ plan.plan.planName }}</div>
              <div class="plan-price">
                <span class="original-price">
                  <span class="currency">₹</span>{{ subscriptionType == 'MONTHLY' ? plan.prices.monthlyPrice
                  : plan.prices.yearlyPrice }}
                </span>
                <span class="currency">₹</span>{{
                subscriptionType == 'MONTHLY' ? plan.prices.monthlySellingPrice :
                plan.prices.yearlySellingPrice
                }}<span class="span-tag">{{ subscriptionType === 'MONTHLY' ? '/mo' : '/year' }}</span>
              </div>
            </div>
            <div class="pricing-content">
              <button (click)="upgradePlan(plan)" class="button get-business-button">Get Business</button>

              <div class="plan-name features-heading" style="margin-top:10px">What's included?</div>
              <div class="body-desc content-options" style="text-align:justify">
                <div
                  *ngFor="let content of ((data?.plan?.paidPlanId != null && !showAll) ? plan.features.slice(0,4) : plan.features); let i = index"
                  class="d-flex gap-15 features">
                  <img alt="" src="./../../../../assets/images/business/feature_check.svg">
                  {{ content }}
                </div>

                <!-- Show the toggle button only when paid and there are more than 6 features -->
                <div *ngIf="data?.plan?.paidPlanId != null && plan?.features?.length > 4" class="mt-2">
                  <button class="btn btn-link p-0" (click)="toggleShowAll()" [attr.aria-expanded]="showAll">
                    {{ showAll ? 'Show less' : 'Show more' }}
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="ai-growth-partner-section" *ngIf="!isCustomPlan">
      <div class="ai-growth-partner-header">
        <div class="section-title">AI Growth Partner</div>
        <div class="section-subtitle">Unlimited users</div>
      </div>
      <div class="row ai-growth-partner-content">
        <div class="col-md-6 col-12">
          <div class="d-flex gap-15 features">
            <img alt="" src="./../../../../assets/images/business/feature_check.svg">
            Customised Website
          </div>
          <div class="d-flex gap-15 features">
            <img alt="" src="./../../../../assets/images/business/feature_check.svg">
            Unlimited Leads
          </div>
          <div class="d-flex gap-15 features">
            <img alt="" src="./../../../../assets/images/business/feature_check.svg">
            Teller-Made Website Design
          </div>
          <div class="d-flex gap-15 features">
            <img alt="" src="./../../../../assets/images/business/feature_check.svg">
            Custom SEO Strategies
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="d-flex gap-15 features">
            <img alt="" src="./../../../../assets/images/business/feature_check.svg">
            Custom Integrations
          </div>
          <div class="d-flex gap-15 features">
            <img alt="" src="./../../../../assets/images/business/feature_check.svg">
            Custom Social Solutions, Unlimited blogs
          </div>
          <div class="d-flex gap-15 features">
            <img alt="" src="./../../../../assets/images/business/feature_check.svg">
            AI Based Lead Scoring And Management
          </div>
          <div class="d-flex gap-15 features">
            <img alt="" src="./../../../../assets/images/business/feature_check.svg">
            Customisable HR Solution
          </div>
        </div>
      </div>
      <div class="text-center">
        <button (click)="contactUs()" class="button contact-sales-button">Contact Sales Team</button>
      </div>
    </div>
  </div>
</section>